
import Arms from 'alife-logger';

if (process.env.NODE_ENV !== 'development') {
  const environment = {
    local: 'local',
    DEV: 'daily',
    UAT: 'pre',
    PRO: 'prod',
  }[process.env.CONFIG_ENV.toUpperCase() || 'local'];
  Arms.singleton({
    pid: process.env.ARMS_PID,
    appType: 'web',
    imgUrl: process.env.ARMS_URL,
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    environment,
    // release: RELEASE,
    ignore: {
      // 忽略指定URL/API/JS错误
      ignoreUrls: [/.*apm-server.*/, /.*google-analytics.*/, /.*sentry.*/],
      ignoreApis: [/.*apm-server.*/, /.*google-analytics.*/, /.*sentry.*/, /.*doubleclick.net.*/],
    },
  });
}
